export default [
  {
    url: "/user/subscriptions",
    name: "User Profile",
    icon: "bxs-user"
  },
  // {
  //   url: "/user/cards",
  //   name: "Card Details",
  //   icon: "bx-credit-card-alt"
  // },
  {
    url: "/user/tickets",
    name: "Tickets",
    icon: "bxs-chat"
  },
  {
    name: "Logout",
    icon: "bx-log-out",
    operation: "logout"
  },
  {
    name: "Support",
    operation: "openChatWidget",
    icon: "bx-support"
  }
];
